import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api } from "../lib/api";
import { TriangleAlert } from "lucide-react";

const levelColor = {
  Awas: "bg-red-600",
  Siaga: "bg-orange-600",
  Waspada: "bg-amber-500",
};

export const AlertBanner = () => {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/alerts").then((r) => setAlerts(r.data)).catch(() => {});
  }, []);
  if (!alerts.length) return null;
  const top = alerts[0];
  return (
    <div className={`${levelColor[top.level] || "bg-orange-600"} text-white`} data-testid="alert-banner">
      <Marquee speed={45} pauseOnHover gradient={false} className="py-2">
        {alerts.map((a) => (
          <span key={a.id} className="inline-flex items-center gap-2 mx-10 text-sm font-semibold">
            <TriangleAlert size={15} className="shrink-0" />
            <span className="font-mono text-xs uppercase tracking-[0.2em] bg-white/20 px-2 py-0.5 rounded">{a.level}</span>
            {a.title} — {a.message} <span className="opacity-75 font-normal">({a.source})</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
